import React, { useEffect, useState } from 'react'
import ItemsApp, { IInventoryModel, IItemModel } from '../items/ItemsApp'
import { IRequestedItemAllocation, ItemsRequestModel } from '.'
import { Button, Checkbox, IconButton, Skeleton, Tooltip } from '@mui/material'
import Thumbnail from '../../components/Thumbnail'
import StatusChip from '../../components/StatusChip'
import GenerateIcon from '../../components/GenerateIcon'
import { useDispatch } from 'react-redux'
import { error } from 'console'
import { handleRequestError } from '../../services/api'
import BasicModalWindow from '../../components/BasicModalWIndow'
import { SingleItemInventoryBox } from '../items/ItemInventory'
import QuantitySlider from '../transactions/QuantitySlider'
import { handleCloseElementQuickPreview, handleOpenElementQuickPreview } from '../admin/adminPagesSlice'

export interface ISelectedItemForRequestModel extends IItemModel{
    allocations: IRequestedItemAllocation[],
}

interface ISelectedItemForRequestProps extends ISelectedItemForRequestModel{
    selectedItems: ISelectedItemForRequestModel[],
    setSelectedItems: (items: ISelectedItemForRequestModel[]) => void,
    items: ISelectedItemForRequestModel[],
    setItems: (items: ISelectedItemForRequestModel[]) => void,
    request?: ItemsRequestModel | null,
}

export default function SelectedItemForRequest(props: ISelectedItemForRequestProps) {

    const dispatch = useDispatch()

    const {
        id,
        title,
        thumbnail,
        status,
        available_quantity,
        selectedItems,
        unique_id,
        setSelectedItems,
        items,
        setItems,
        allocations,
        request,
    } = props

    const baseContainerClassName: string = "selected-item-for-request"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    const [tooltip, setTooltip] = useState<string>("Select item")
    const [enableCheckbox, setEnableCheckbox] = useState<boolean>(true)

    // const [allocations, setAllocations] = useState<IRequestedItemAllocation[]>(props.allocations)
    const [inventory, setInventory] = useState<IInventoryModel[]>([])

    const [open, setOpen] = useState<boolean>(false)

    const [loadingAllocationsStatus, setLoadingAllocationsStatus] = useState<boolean>(false)
    const [loadingInventory, setLoadingInventory] = useState<boolean>(false)

    const [quantityModal, setQuantityModal] = useState<boolean>(false)

    const [quantity, setQuantity] = useState<number>(0)
    const [maxQuantity, setMaxQuantity] = useState<number>(0)
    const [currentInventory, setCurrentInventory] = useState<IInventoryModel | null>()

    const itemsApp = new ItemsApp()

    const updateItemAllocations = (id: number, allocations: IRequestedItemAllocation[]) => {
        if (items.find((item) => item.id === id)){

            const findIndex = items.findIndex((item) => item.id === id)

            if (items[findIndex]){

                let newItems = [...items]

                if (newItems[findIndex]){
                    newItems[findIndex] = {
                        ...newItems[findIndex],
                        allocations: allocations
                    }

                    setItems(newItems)
                }

            }

        }
    }

    /**
     * Count allocated qnt
     */
    const countAllocatedQnt = () => {
        let qnt: number = 0

        if (allocations && allocations.length > 0){
            allocations.map((allocation) => {
                qnt += allocation.quantity
            })
        }

        return qnt
    }

    /**
     * Update enableCheckbox
     */
    useEffect(() => {

        let enable: boolean = false

        if (allocations.length > 0 && countAllocatedQnt() > 0){
            enable = true
            setTooltip("Select item")
        }else{
            setTooltip("Update Requested Quantity first!")
        }

        setEnableCheckbox(enable)

    }, [enableCheckbox, allocations])

    /**
     * Load inventory
     */
    const loadInventory = () => {
        // if (hasLoaded){
        //     return;
        // }

        setLoadingInventory(true)

        itemsApp.itemInventory(unique_id)
            .then(response => {

                const list = response.data
                setInventory(list)
                setLoadingInventory(false)
                // setHasLoaded(true)

            })
            .catch(error => {
                handleRequestError(error, dispatch)
                setLoadingInventory(false)
            })

    }

    const handleOpenQntModalOneAllocation = (allocations: IRequestedItemAllocation[], inventory: IInventoryModel[]) => {
        if (allocations.length > 1){
            setOpen(true)

            return;
        }

        const firstAllocation = allocations[0]

        const findInventoryRecord = inventory.find(
            (record) =>
                record.warehouse_id === firstAllocation.warehouseId &&
                record.section_id === firstAllocation.sectionId &&
                record.location_id === firstAllocation.locationId
        )

        if (findInventoryRecord) {
            handleOpenQuantityModal(findInventoryRecord);
        }
    }

    /**
     * Handle open requested qnt modal
     */
    const handleOpenRequestedQntModal = () => {

        if (allocations.length > 1){
            setOpen(true)
            loadInventory()
        }else{

            let firstAllocation = allocations[0]

            if (firstAllocation){
                handleOpenQntModalOneAllocation(allocations, inventory)
            }else{
                loadingAllocations()
            }

        }

    }

    const handleCloseRequestedQntModal = () => {
        setOpen(false)
    }

    const toggleSelect = () => {
        let selectedItemsList = [...selectedItems];

        const isSelected = selectedItemsList.some(item => item.id === id);

        if (isSelected) {
            // Remove it
            selectedItemsList = selectedItemsList.filter(item => item.id !== id);
        } else {
            // Add it
            selectedItemsList.push(props);
        }

        setSelectedItems(selectedItemsList)
    }

    const isItemSelected = () => {
        return selectedItems.some(item => item.id === id)
    }

    /**
     * Load allocations
     */
    const loadingAllocations = () => {

        setLoadingAllocationsStatus(true)

        itemsApp.itemInventory(unique_id)
            .then(response => {

                let allocationsList: IRequestedItemAllocation[] = []

                const { data } = response

                console.log("data", data)

                if (data){
                    data.map((inv: any) => {
                        if (inv){

                            if (inv.user_id){
                                return;
                            }

                            if (inv.quantity > 0){
                                allocationsList.push({
                                    warehouseId: inv.warehouse_id,
                                    sectionId: inv.section_id,
                                    quantity: inv.quantity,
                                    locationId: inv.location_id,
                                    is_rejected: false,
                                    is_returned: false,
                                    missing_qnt: 0,
                                    damaged_qnt: 0
                                })
                            }
                        }
                    })
                }

                setLoadingAllocationsStatus(false)
                
                updateItemAllocations(id, allocationsList)

                setInventory(data)   

                handleOpenQntModalOneAllocation(allocationsList, data)

            })
            .catch(error => {
                setLoadingAllocationsStatus(false)
                handleRequestError(error, dispatch)
            })

    }

    useEffect(() => {
        if (allocations.length === 0){
            // loadingAllocations()
        }else{

            const findItemIndex = selectedItems.findIndex((record) => record.id === id)

            if (selectedItems[findItemIndex]){

                let updatedList = [...selectedItems]
                updatedList[findItemIndex] = {
                    ...updatedList[findItemIndex],
                    allocations: allocations
                }

                setSelectedItems(updatedList)

            }

        }

    }, [allocations])

    /**
     * Handle close quantity modal
     */
    const handleHideQuantityModal = () => {
        setQuantityModal(false)
        setCurrentInventory(null)
        setQuantity(0)
        setMaxQuantity(0)
        // handleCloseRequestedQntModal()
    }

    /**
     * Handle open quantity modal
     */
    const handleOpenQuantityModal = (inventory: IInventoryModel) => {
        setQuantityModal(true)

        let quantity: number = inventory.quantity

        // if (request && request.status === "pending"){
        //     quantity = inventory.quantity + inventory.reserved_quantity
        // }

        setMaxQuantity(quantity)
        setCurrentInventory(inventory)

        setQuantity(1)
    }

    /**
     * Custom buttons
     */
    const customButtons = (inventory: IInventoryModel) => {

        if (inventory.user_id){
            return <></>
        }

        return(
            <>
                <Button disabled={inventory.quantity > 0 ? false : true} className="general-button admin-button" color="success" onClick={() => handleOpenQuantityModal(inventory)}>Update Quantity</Button>
            </>
        )
    }

    /**
     * Render inventory
     */
    const renderInventory = () => {

        if (loadingInventory){
            return(
                <>
                    <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                    <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                    <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                </>
            )
        }

        return inventory.map((item, index) => {

            let inventoryRecord = item
            
            const findAllocation = allocations.find(
                (allocation) =>
                    allocation.warehouseId === inventoryRecord.warehouse_id &&
                    allocation.sectionId === inventoryRecord.section_id &&
                    allocation.locationId === inventoryRecord.location_id
            )

            if (findAllocation) {
                inventoryRecord.reserved_quantity = findAllocation.quantity;
            }

            return <SingleItemInventoryBox viewRequestPage={false} {...inventoryRecord} key={index} customButtons={customButtons} />
        })
    }

    /**
     * Update allocations
     */
    const handleUpdateAllocations = () => {
        if (!currentInventory){
            return;
        }

        const findAllocationIndex = allocations.findIndex(
            (allocation) =>
                allocation.warehouseId === currentInventory.warehouse_id &&
                allocation.sectionId === currentInventory.section_id &&
                allocation.locationId === currentInventory.location_id
        )

        let allocationsList = [
            ...allocations
        ]

        if (allocationsList[findAllocationIndex]){
            allocationsList[findAllocationIndex] = {
                ...allocationsList[findAllocationIndex],
                quantity: quantity
            }

            updateItemAllocations(id, allocationsList)
            handleHideQuantityModal()
        }

    }

    return(
        <div className="wrapper-of-selected-item-for-request">

            <BasicModalWindow
                shown={open}
                handleClose={handleCloseRequestedQntModal}
                size="md"
                title="Requested quantity"
                actionButtonsBottom
                actionButtons={[
                    {
                        label: "Close",
                        onClick: handleCloseRequestedQntModal,
                        color: "error"
                    }
                ]}
            >
                {renderInventory()}
            </BasicModalWindow>

            <BasicModalWindow
                shown={quantityModal}
                handleClose={handleHideQuantityModal}
                size="sm"
                showHeader
                title="Quantity"
                actionButtons={[
                    {
                        label: "Done",
                        onClick: handleUpdateAllocations,
                        color: "success"
                    },
                    {
                        label: "Close",
                        onClick: handleHideQuantityModal,
                        color: "error"
                    }
                ]}
                actionButtonsBottom
            >
                <QuantitySlider allowZero itemMaxAvailableQnt={maxQuantity} quantity={quantity} updateQuantity={(qnt) => setQuantity(qnt)} />
            </BasicModalWindow>

            <div className={containerClassName}>
                <div className="content-of-selected-item-for-request">

                    <div className="info-boxes-of-selected-item-for-request">
                        <div className="content-of-info-boxes-of-selected-item-for-request">

                            <Tooltip title={tooltip}   PopperProps={{
                                disablePortal: true
                            }}>
                                <div className="info-box-of-info-boxes-of-selected-item-for-request checkbox">
                                    <div className="content-of-info-box-of-info-boxes-of-selected-item-for-request">
                                        <Checkbox disabled={enableCheckbox ? false : true} checked={isItemSelected()} inputProps={{ 'aria-label': 'controlled' }} onChange={(e) => toggleSelect()} />
                                    </div>
                                </div>
                            </Tooltip>

                            <div className="info-box-of-info-boxes-of-selected-item-for-request thumbnail">
                                <div className="content-of-info-box-of-info-boxes-of-selected-item-for-request">
                                    <Thumbnail src={thumbnail} />
                                </div>
                            </div>

                            <div className="info-box-of-info-boxes-of-selected-item-for-request" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-info-box-of-info-boxes-of-selected-item-for-request">
                                    <h4>Item:</h4>
                                    <h3 style={{ cursor: "pointer" }} onClick={() => handleOpenElementQuickPreview(
                                        id,
                                        title,
                                        () => new ItemsApp(),
                                        dispatch,
                                        [
                                             {
                                                label: isItemSelected() ? "Deselect Item" : "Select Item",
                                                color: "success",
                                                onClick: () => {
                                                    toggleSelect()
                                                    handleCloseElementQuickPreview(dispatch)
                                                },
                                                disabled: enableCheckbox ? false : true
                                            },
                                            {
                                                label: "Close",
                                                color: "error",
                                                onClick: () => handleCloseElementQuickPreview(dispatch)
                                            }
                                        ],
                                        false,
                                        undefined,
                                        true
                                    )}>{title}</h3>
                                </div>
                            </div>

                            <div className="info-box-of-info-boxes-of-selected-item-for-request status" style={{ minWidth: 100, maxWidth: 100 }}>
                                <div className="content-of-info-box-of-info-boxes-of-selected-item-for-request">
                                    <StatusChip type={status} />
                                </div>
                            </div>

                            <div className="info-box-of-info-boxes-of-selected-item-for-request" style={{ minWidth: 90, maxWidth: 90 }}>
                                <div className="content-of-info-box-of-info-boxes-of-selected-item-for-request">
                                    <h4>Available qnt:</h4>
                                    <h3>{available_quantity}</h3>
                                </div>
                            </div>

                            <div className="info-box-of-info-boxes-of-selected-item-for-request" style={{ minWidth: 90, maxWidth: 90 }}>
                                <div className="content-of-info-box-of-info-boxes-of-selected-item-for-request">
                                    <h4>
                                        Requested qnt:
                                    </h4>
                                    <h3>
                                        {!loadingAllocationsStatus ? countAllocatedQnt() : <Skeleton variant="text" width={30} />}
                                    </h3>

                                    <IconButton className="edit-item-request-allocation-button" disabled={loadingAllocationsStatus} onClick={() => handleOpenRequestedQntModal()}>
                                        <GenerateIcon icon="edit" />
                                    </IconButton>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="action-buttons-of-selected-item-for-request">
                        <div className="content-of-action-buttons-of-selected-item-for-request">

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}